__turbopack_context__.v({
  "buttonMath": "index-module-scss-module__xz-jfW__buttonMath",
  "buttonMinus": "index-module-scss-module__xz-jfW__buttonMinus",
  "buttonPlus": "index-module-scss-module__xz-jfW__buttonPlus",
  "controlValue": "index-module-scss-module__xz-jfW__controlValue",
  "controlsHolder": "index-module-scss-module__xz-jfW__controlsHolder",
});
